//TODO add to launchdarkly

export enum Features {
  HBO_GO_ACTIVATE_PLAN = 'HBO_GO_ACTIVATE_PLAN',
  CREDIT_CARD_INDICATOR = 'CREDIT_CARD_INDICATOR',
  PURCHASE_MS_CLIENT = 'PURCHASE_MS_CLIENT',
  LOGIN_FORM = 'LOGIN_FORM',
  OTT_LOGIN = 'OTT_LOGIN',
  GDPR = 'GDPR',
  ANALYTICS = 'ANALYTICS',
  USER_MIGRATION_CHECK = 'USER_MIGRATION_CHECK',
  SUBSCRIPTION_SETS_TTL = 'SUBSCRIPTION_SETS_TTL',
}

export const envs = [
  {
    id: 3194,
    name: 'com.Kaltura.proximus.',
    title: 'Proximus',
  },
  {
    id: 3200,
    name: 'com.Kaltura.telenorserbia.',
    title: 'Telenor Serbia',
  },
  {
    id: 3207,
    name: 'com.Kaltura.kux.',
    title: 'KUX',
  },
  {
    id: 3201,
    name: 'com.Kaltura.o2czechia.',
    title: 'O2 CZ',
  },
  {
    id: 3204,
    name: 'com.Kaltura.telenorhungary.',
    title: 'Telenor Hungary',
  },
  {
    id: 5002,
    name: 'com.Kaltura.telenorbulgaria.',
    title: 'Telenor Bulgaria',
  },
  {
    id: 3206,
    name: 'com.Kaltura.o2sk.',
    title: 'O2 SK',
  },
  {
    id: 5033,
    name: 'com.Kaltura.kux.',
    title: 'Demo',
  },
];

export const stages = [
  {
    name: 'Stage',
    url: 'frs1',
  },
  { name: 'Pre-Prod', url: 'frt1' },
  { name: 'Prod', url: 'frp1' },
];
